import React, { useContext } from 'react';
import { LocalContext } from '../providers/locale';

export const withLocale = (ComponentToWrap) => (props) => {
  const locale = useContext(LocalContext);
  return (
    <ComponentToWrap
      {...props}
      locale={locale}
    />
  );
};
